import React, { useEffect, useState } from 'react'
import { axiosWithAuth } from './withAuth'
import { Dialog } from '../components/ui/Dialog/Dialog'
import { LockFill } from '../assets/icons'
import { Typography } from '../components/ui/Typography/Typography'
import { Button } from '../components/ui/Button/Button'
import { L_HTML } from '../components/providers/Lokalise'
import { logout } from '../utils/Logout'

const REDIRECT_TO_FOA_CODES = [455, 456, 482, 483, 484, 490, 491, 494, 495]

const Interceptor: React.FC = ({ children }) => {
    const [apiError, setApiError] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<
        React.ReactNode | undefined
    >(undefined)
    const [errorStatusCode, setErrorStatusCode] = useState<number | undefined>(
        undefined
    )

    useEffect(() => {
        const setError = (): void => {
            setApiError(true)
        }
        const interceptorId = axiosWithAuth.interceptors.response.use(
            (response) => {
                return response
            },
            (error) => {
                if (error.response.status === 503) {
                    setError()
                    setErrorMessage(L_HTML('ERROR_503_MESSAGE'))
                    setErrorStatusCode(503)
                    return {
                        error: error.response.data,
                    }
                }

                if (error.response.status > 401) {
                    setError()
                    setErrorMessage(
                        error.response.data.Message &&
                            error.response.data.Message !== ''
                            ? error.response.data.Message
                            : 'Kontakt din afdeling, hvis fejlen fortsætter'
                    )

                    setErrorStatusCode(error.response.status)
                    return {
                        error: error.response.data,
                    }
                }

                return {
                    error: error?.response?.data,
                }
            }
        )
        return () => {
            axiosWithAuth.interceptors.request.eject(interceptorId)
        }
    }, [])

    const closeDialog = (): void => {
        if (errorStatusCode) {
            if (REDIRECT_TO_FOA_CODES.indexOf(errorStatusCode) !== -1) {
                window.location.href = 'https://www.foa.dk/'
            }
            if (errorStatusCode === 503) {
                logout()
            }
        }

        setErrorMessage(undefined)
        setApiError(false)
        setErrorStatusCode(undefined)
    }

    return (
        <>
            <>{children}</>

            {apiError ? (
                <Dialog
                    trigger={null}
                    defaultOpen
                    hideClose
                    icon={<LockFill width="46px" />}
                >
                    <Typography
                        style={{ marginBottom: '30px' }}
                        size="L"
                        align="center"
                    >
                        Der skete en fejl
                    </Typography>
                    <Typography
                        tag="p"
                        size="S"
                        style={{ marginBottom: '30px' }}
                        align="center"
                    >
                        {errorMessage}
                    </Typography>
                    <Button size="xlarge" onClick={closeDialog}>
                        OK
                    </Button>
                </Dialog>
            ) : null}
        </>
    )
}

export default Interceptor
